<template>
  <v-container fluid class="py-0">
    <patient-header />

    <div v-if="paramsToShow && paramsToShow.length" class="d-flex mb-4 flex-wrap" style="gap:8px;">
      <v-card v-for="(param, index) in paramsToShow" :key="index" class="d-flex ma-0 pa-0 flex-grow-1" style="flex-basis:250px;">
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title class="headline">{{ param.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ param.final_mean.toFixed(2) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </div>

    <v-row class="mb-2">
      <v-col v-if="showHealthGroup" cols="12" sm="3">
        <health-group />
      </v-col>

      <v-col>
        <div class="d-flex mb-4 flex-wrap" style="gap:16px;">
          <modal depressed icon="add" title="Добавить диагноз" name="Диагноз" component="add-diseases"></modal>
          <modal depressed icon="add" title="Добавить лекарство" name="Лекарство" component="add-medicine"></modal>
          <modal
            depressed
            icon="add"
            class="ml-4"
            title="Назначить лекарство"
            name="Рецепт"
            component="add-medicine-reciept"
          ></modal>
          <v-btn depressed color="primary" title="Запись на прием" @click="showCalendar">
            <v-icon left>add</v-icon>
            Запись на прием
          </v-btn>
          <v-btn depressed color="primary" title="Добавить документ" @click="addDocument">
            <v-icon left>add</v-icon>
            Документ
          </v-btn>
        </div>
      </v-col>

      <!--<v-col align="center">
        <v-btn
            depressed
            color="primary"
            title="Записать на приём"
            @click="sheet = !sheet">
          <v-icon left>add</v-icon>
          приём
        </v-btn>

        <v-bottom-sheet v-model="sheet">
          <v-sheet class="text-center" height="200px">
            <v-btn
                class="mt-6"
                text
                color="red"
                @click="sheet = !sheet"
            >Закрыть
            </v-btn>
            <div class="py-3">This is a bottom sheet using the controlled by v-model instead of
              activator
            </div>
          </v-sheet>
        </v-bottom-sheet>
      </v-col>-->
    </v-row>

    <v-card class="mb-2">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="3">
            <input-save
              label="Количество сигарет в день"
              field="field_24"
              :param="12"
              :measure="13"
              hide-details
              class="ma-0 pa-0"
            />
          </v-col>

          <v-col>
            <input-save
              hide-details
              class="ma-0 pa-0"
              label="Слабый алкоголь мл/день"
              field="field_24"
              :param="13"
              :measure="11"
            />
          </v-col>

          <v-col>
            <input-save
              hide-details
              class="ma-0 pa-0"
              label="Крепкий алкоголь мл/день"
              field="field_24"
              :param="14"
              :measure="11"
            />
          </v-col>

          <v-col align="center">
            <input-save hide-details class="ma-0 pa-0" label="Спорт" field="field_24" :param="15" :measure="14" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <diseases />
    <AllergyList></AllergyList>
    <inspections />
    <agenda />
    <Parameters hide-patient></Parameters>
    <AnalyzDocumentList></AnalyzDocumentList>
    <reciepts />
    <Drugs hide-patient></Drugs>
    <calendar />
    <!-- <metric-report v-if="$config.VUE_APP_SHOW_ALL_METRICS_IKP" />
    <IkpMedParamsExcessMeasurement
      :show-med-params-average-measurement-chart="$config.SHOULD_SHOW_MED_PARAMS_AVERAGE_MEASUREMENT_CHART"
      :show-med-params-excess-measurement-chart="$config.SHOULD_SHOW_MED_PARAMS_EXCESS_MEASUREMENT_CHART"
    /> -->
    <LogEvents></LogEvents>
  </v-container>
</template>

<script>
import PatientHeader from "@/components/PatientHeader";
import Modal from "@/components/Modal";
import Diseases from "@/views/pages/diseases/components/Diseases";
import AllergyList from "@/views/pages/allergy/components/AllergyList";
import Drugs from "@/views/pages/drugs/Drugs";
import Parameters from "@/views/pages/parameters/Parameters";
import MetricReport from "./components/MetricReport";
import LogEvents from "./components/LogEvents";
import Inspections from "./components/Inspections";
import Agenda from "./components/Agenda";
import Calendar from "./components/Calendar";
import Reciepts from "./components/Reciepts";
import InputSave from "@/components/forms/InputSave";
import SelectSave from "@/components/forms/SelectSave";
import HealthGroup from "./components/HealthGroup";
import IkpMedParamsExcessMeasurement from "@/views/pages/ikp/components/IkpMedParamsExcessMeasurement.vue";
import AddDocument from "@/modules/documents/add-document/AddDocument.vue";
import AnalyzDocumentList from "@/views/pages/laboratory-research/components/AnalyzDocumentList.vue";
import { FLAGS } from "@/configs";

export default {
  name: "IKP",

  components: {
    IkpMedParamsExcessMeasurement,
    HealthGroup,
    SelectSave,
    InputSave,
    Modal,
    Calendar,
    Reciepts,
    Agenda,
    Inspections,
    MetricReport,
    Diseases,
    AllergyList,
    PatientHeader,
    Drugs,
    Parameters,
    AnalyzDocumentList,
    LogEvents,
  },

  data: () => ({
    dialog: false,
    date: "",
    sheet: "",
    menu: "",
    paramsToShow: [],
  }),
  computed: {
    showHealthGroup() {
      const hgFlag = this.$featureFlags.feature(FLAGS.HIDE_IKP_HEALTH_GROUP);
      return hgFlag._value !== "1";
    },
    customerId() {
      return this.$store.state.customer.id;
    },
  },
  async created() {
    const needed = ["ИМТ", "Индекс SCORE"];
    const response = await this.$http.get(`v1/customers/${this.customerId}/all-metrics-report`, {
      params: {
        measurements_count: 5,
        language: "ru",
      },
    });
    response.data.data.forEach(element => {
      if (needed.includes(element.name)) {
        this.paramsToShow.push(element);
      }
    });
  },

  methods: {
    addDocument() {
      this.$dialog.showAndWait(AddDocument, { width: "600px", persistent: true });
    },
    showCalendar() {
      const calendar = document.querySelector("#calendar");
      if (calendar) {
        calendar.scrollIntoView({ behaviour: "smooth", block: "center" });
      }
    },
  },
};
</script>
